var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 10.797V6.723c0-.392 0-.588-.05-.77a1.451 1.451 0 0 0-.21-.454c-.107-.156-.258-.286-.56-.544L8.58 1.87c-.56-.48-.84-.72-1.154-.81a1.532 1.532 0 0 0-.852 0c-.315.09-.594.33-1.153.809L1.82 4.955c-.302.258-.452.388-.56.544a1.453 1.453 0 0 0-.211.453C1 6.135 1 6.331 1 6.723v4.074c0 .684 0 1.026.114 1.296.152.36.444.646.812.795C2.2 13 2.55 13 3.25 13c.699 0 1.049 0 1.324-.112.368-.149.66-.435.812-.795.114-.27.114-.612.114-1.296v-.734c0-.811.672-1.469 1.5-1.469s1.5.658 1.5 1.469v.734c0 .684 0 1.026.114 1.296.152.36.444.646.812.795C9.7 13 10.05 13 10.75 13c.699 0 1.049 0 1.324-.112.368-.149.66-.435.812-.795.114-.27.114-.612.114-1.296Z",
    stroke: "#999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgHome;